module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Snow-39f0edbc825a6215712fb8b182ad1cc4.svg";